import { DeviceRow } from 'components/tables/data/device/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the device id.
 */
export default function DeviceIdColumn({ data: { deviceId } }: { data: DeviceRow }) {
  return <P3Regular color="gray.8">{deviceId}</P3Regular>;
}
